import React from "react";
export default () => {
  let backgroundImage="assets/img/shape/footer-map.png";
  return (
      <>
        <footer class="main-footer position-relative">
          <div class="footer-bg" style={{backgroundImage: `url(${backgroundImage})`}}></div>
          <div class="mkt-container">
              <div class="footer-upper">
                  <div class="row">
                      <div class="col-lg-4 col-md-6">
                          <div class="newsletter-widget">
                              <h3 class="footer-widget-title">Newsletter</h3>
                              <div class="newsletter-form">
                                  <form action="#">
                                      <input type="email" name="email" placeholder="Your email" required/>
                                      <button type="submit"><i class="fa fa-arrow-right-long"></i></button>
                                  </form>
                              </div>
                              <div class="footer-logo">
                                  <img src="assets/img/grspaces.jpeg" alt=""/>
                              </div>
                          </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="footer-middle-widgets">
                              <div class="footer-widget-1">
                                  <h3 class="footer-widget-title">Explore</h3>
                                  <ul class="footer-menu-list">
                                      <li><a href="/">Home</a></li>
                                      <li><a href="/#Abount">About</a></li>
                                      <li><a href="/#Services">Service</a></li>
                                      <li><a href="/#Contact">Contact</a></li>
                                  </ul>
                              </div>
                              <div class="footer-widget-2">
                                  <h3 class="footer-widget-title">Connect</h3>
                                  <ul class="footer-menu-list">
                                      <li><a href="#">Instagram</a></li>
                                      <li><a href="#">Facebook</a></li>
                                      <li><a href="#">YouTube</a></li>
                                      <li><a href="#">Twitter</a></li>
                                  </ul>
                              </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                          <div class="footer-contact-widget">
                              <h6>Send Your Email</h6>
                              <h2><a href="mailto:infoyour@website.net">info@grspaces.com</a></h2>
                              <h3 class="footer-widget-title">Contact</h3>
                              <ul class="contact-info-list">
                                  <li>Madison Avenue 21c</li>
                                  <li><a href="tel:0041122012">00 411 22 012</a></li>
                                  <li><a href="tel:0041122012">00 411 22 012</a></li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>       
          </div>
          <div class="footer-bottom text-center">
              <p>Copyright © 2025 <a href="#">GRspaces.</a> All rights reserved.</p>
          </div>
      </footer>
      </>
  );
};
